import { gql, useSubscription } from '@apollo/client'

export const APPOINTMENTS_WIDGET_SUBSCRIPTION = gql`
  fragment AppointmentWidgetFields on Appointment {
    id
    scheduledStartDatetime
    businessAppointmentType {
      id
      name
    }
    appointmentReason {
      id
      name
    }
    notes
    state {
      id
      name
    }
  }

  subscription AppointmentsWidget(
    $patientId: ID!
    $offset: PageOffset = 0
    $limit: PageLimit = 10
    $includePrevious: Boolean = false
    $includeScheduled: Boolean = false
  ) {
    appointmentWidget(patientId: $patientId, offset: $offset, limit: $limit) {
      previous @include(if: $includePrevious) {
        ...AppointmentWidgetFields
      }
      scheduled @include(if: $includeScheduled) {
        ...AppointmentWidgetFields
      }
      appointmentCounters {
        previous
        scheduled
      }
    }
  }
`

export interface AppointmentsWidgetSubscriptionOptions {
  includePrevious?: boolean
  includeScheduled?: boolean
  limit?: number
  offset?: number
  patientId: string
}

export const useAppointmentsWidgetSubscription = ({
  patientId,
  offset = 0,
  limit = 10,
  includePrevious = false,
  includeScheduled = false,
}: AppointmentsWidgetSubscriptionOptions) =>
  useSubscription(APPOINTMENTS_WIDGET_SUBSCRIPTION, {
    variables: {
      patientId,
      offset,
      limit,
      includePrevious,
      includeScheduled,
    },
    skip: !patientId,
  })
